// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_container__40pKZ {
  height: 100vh;
  width: 100vw;
  position: relative;
  overflow-y: hidden; }

@media (max-width: 768px) {
  .styles_header__FYgxE {
    box-shadow: unset;
    padding: unset; } }
`, "",{"version":3,"sources":["webpack://./src/modules/Core/sub-modules/ui-kit/components/SplitScreen/styles.module.scss","webpack://./src/modules/Core/styles/mixins.scss"],"names":[],"mappings":"AAGA;EACE,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,kBAAkB,EAAA;;ACClB;EDEF;IAEI,iBAAiB;IACjB,cAAc,EAAA,EAEjB","sourcesContent":["@import \"src/modules/Core/styles/variables.scss\";\n@import \"src/modules/Core/styles/mixins.scss\";\n\n.container {\n  height: 100vh;\n  width: 100vw;\n  position: relative;\n  overflow-y: hidden;\n}\n\n.header {\n  @include mobile {\n    box-shadow: unset;\n    padding: unset;\n  }\n}\n\n","// @import \"src/modules/Core/styles/mixins.scss\";\n@mixin respond-to($breakpoint) {\n  @media (max-width: $breakpoint) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 768px) {\n    @content;\n  }\n}\n\n@mixin multilineText($lines){\n  -webkit-line-clamp: $lines;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  display: -webkit-box;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `styles_container__40pKZ`,
	"header": `styles_header__FYgxE`
};
export default ___CSS_LOADER_EXPORT___;
